import { HttpStatusCode } from 'enums/http-status-code';
import { rejectResponseByStatusCode } from 'api/interceptors/reject-response-by-status-code.interceptor';

export const rejectGracefullyBadRequestResponse = rejectResponseByStatusCode(
  HttpStatusCode.GRACEFULLY_BAD_REQUEST,
);
